<template>
<div class="card">
    <div class="card-header">Screen Applicants</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="09"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="09" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <BaseSwitchInput v-model="bypass"
                                     :v="$v.bypass"
                                     label="Bypass Send Candidate Roster to Manager?"
                                     tip=""
                                     :v-if="this.request?.requestTypeValue?.code !== '10'"
                    />
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                     <BaseDateInput v-model="request.dd14ReceivedDate" 
                            :v="$v.request.dd14ReceivedDate"
                            label="DD-214 Received Date"
                            slug="dd14-date"
                            :required="$v.request.dd14ReceivedDate.$params.required"/> 
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.screeningComments"
                        :v="$v.request.screeningComments" 
                        slug="screeningComments"
                        label="Internal Comments"/>
                </b-col>
            </b-row>

            <b-row v-if="bypass">
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.selectedCandidateName"
                                   :v="$v.request.selectedCandidateName"
                                   label="Selected Candidate Name"
                                   tip=""
                                   slug="candidateName"
                                   :required="$v.request.selectedCandidateName.$params.required"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.selectedCandidateEmail"
                                   :v="$v.request.selectedCandidateEmail"
                                   label="Selected Candidate Email"
                                   tip=""
                                   slug="candidateEmail"
                                   :required="$v.request.selectedCandidateEmail.$params.required"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.selectedCandidateEmployeeId"
                                   :v="$v.request.selectedCandidateEmployeeId"
                                   label="Selected Candidate Employee ID"
                                   tip=""
                                   slug="candidateEmpId"
                                   :required="$v.request.selectedCandidateEmployeeId.$params.required"/>
                </b-col>
            </b-row>
                        
            <div>
                <b-button type="submit" variant="primary" v-show="false">Complete Screening of Applicants</b-button>
                <b-button type="button" variant="primary" @click="sendRoster" 
                    :disabled="bypass || !hasReqAttachments()">Send Candidate Roster to Manager</b-button>
                <b-button type="button" variant="primary" @click="complete" :disabled="!bypass">Complete and Advance to Pre Offer Review</b-button>
                <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
                <b-button type="button" variant="outline-primary" @click="repost">Repost Position</b-button>
            </div>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return { 
            checklistComplete: false,
            comments: '',
            saveOnly: false,
            attachmentReqs: [],
            bypass: this.request?.requestTypeValue?.code !== '10',
        }
    },
     validations: {
         bypass: {required},
         comments: { required: false, maxLength: maxLength(4000) },
         checklistComplete: { checked: value => value === true },
         request: { 
             dd14ReceivedDate: { required: false },
             screeningComments: { required: false, maxLength: maxLength(4000) },
             selectedCandidateEmail: { maxLength: maxLength(75),
               required: requiredIf(function (){
                return this.bypass
               })
             },
             selectedCandidateName: {
               maxLength: maxLength(75),
               required: requiredIf(function (){
                 return this.bypass
               })  },
             selectedCandidateEmployeeId: { maxLength: maxLength(75),
               required: requiredIf(function (){
                 return this.bypass
               })
             },
         }
     },

    computed: { },

    created() {
        this.findReqAttachments()
    },
        
    mounted: function() {
        this.autosave()
    },
    
    beforeDestroy() {
       clearInterval(this.autosave_id)
    },
    
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },

        async save() {
            this.saveOnly = true
            await this.onSubmit()
            this.saveOnly = false
        },

        async sendRoster() {
            await this.save()

            let payload = {
                requestId: this.request.id,
                nextLifecycle: '10'
            }
        
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/manager/return/requester`, payload)
              .then(response => {
                this.showRootToast("HRM Request Has Been Sent to Reqester", "Success", "success")
                this.$router.push('/home')
              })
        },

        async complete() {
            await this.save()

            let payload = {
                requestId: this.request.id,
                comments: this.request.interviewComments,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateName: this.request.selectedCandidateName,
                selectedCandidateEmployeeId: this.request.selectedCandidateEmployeeId,
                nextLifecycle: '16'
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/managerInterview`, payload)
                .then(response => {
                    this.showRootToast("HRM Request Has Been Sent to Pre Offer Review", "Success", "success")
                        this.$router.push('/home')
                })
        },

        async onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                dd14ReceivedDate: this.request.dd14ReceivedDate,
                nextLifecycle: '10',
                comments: this.request.screeningComments,
                advanceNextLifecycle: !this.saveOnly,
            }

            await axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/screenApplicants`, payload)
                  .then(response => {                       
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    }
                  })
                  
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        repost() {
            let payload = {
                id: this.request.id,
                transitionStatusTo: '07'
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    this.$router.push('/home') 
                }) 
        },

      hasReqAttachments() {
        if (this.attachmentReqs.length>0) {
          req:
              for (let i=0; i<this.attachmentReqs.length; i++) {
                for (let j=0; j<this.request.attachments.length; j++) {
                  if (this.attachmentReqs[i].attachmentTypeValue.code == this.request.attachments[j].type) {
                    break req;
                  }
                }
                return false;
              }
          return true;
        }
        return true;
      },

      findReqAttachments() {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirements`, {typeCode: this.request.requestTypeValue.code, statusCode: this.request.requestStatusValue.code})
            .then(response => {
              this.attachmentReqs = response.data.filter((req) => req.required == true);
            })
      }
    }   
}
</script>